export default {"src":"/_next/static/media/ra-outline-charter.bd848cf8.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};